import { createContext, useState } from 'react';

type TProps = {
  children: null | Node,
  defaultCompatibility?: ?any
};

export const CompatibilityContext = createContext();

export const CompatibilityProvider = ({ defaultCompatibility, children }: TProps) => {
  let defaultValue;

  if (typeof defaultCompatibility !== 'undefined') {
    defaultValue = defaultCompatibility;
  } else {
    defaultValue = {compatible: true};
  }
  const [compatibility, setCompatibility] = useState(defaultValue);

  return (
    <CompatibilityContext.Provider value={{compatibility, setCompatibility}}>
      {children}
    </CompatibilityContext.Provider>
  );
};
